import React, { useState } from 'react';


import DeleteConfirmationModal from '../../../components/ui/DeleteConfirmationModal';

const DeleteProjectModal = ({ isOpen, onClose, project, onConfirmDelete }) => {
  return (
    <DeleteConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={() => onConfirmDelete(project?.id)}
      itemName={project?.name}
      itemType="Project"
      additionalInfo=""
      warningMessage={
        <>
          This action <strong>cannot be undone</strong>. This will permanently delete the project
          <strong className="text-destructive"> "{project?.name}"</strong> and all associated workflows.
        </>
      }
    />
  );
};

export default DeleteProjectModal;